import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import { TErrorDetails } from '@3.0/Modals/WarningModal/WarningModal.constants';
import { editQuestionModalsSlice } from 'Modules/Studio/Questions/EditQuestion/Layout/Toolbar/redux/editQuestionModalsSlice.slice';
import { propertiesListModalsSlice } from 'Modules/Studio/Questions/EditQuestion/PropertiesList/redux/propertiesListModals.slice';

type TNotificationType = 'info' | 'warning' | 'error';

// Right now we are not using the code returned from the server, so we will need to update this later if we want to use it
export interface INotificationState {
  type: TNotificationType;
  message: string | null;
  error: AxiosError<TErrorDetails> | null;
}

export const notificationInitialState: INotificationState = {
  type: 'info',
  message: null,
  error: null,
};

const NotificationReduxSlice = createSlice({
  name: 'notification',
  initialState: notificationInitialState,
  reducers: {
    clearNotificationMessage: (state: INotificationState) => {
      state.message = null;
      state.type = 'info';
      state.error = null;
    },
    setNotificationMessage: (
      state: INotificationState,
      action: PayloadAction<{
        message: string;
        type?: TNotificationType;
        error: INotificationState['error'];
      }>
    ) => {
      state.message = action.payload.message || 'An unexpected error occurred.';
      state.type = action.payload.type || 'info';
      state.error = action.payload.error;
    },
  },
  extraReducers(builder) {
    // clear error messages when closing modals
    // - runtimeSettings
    // - properties list modals
    builder.addCase(editQuestionModalsSlice.actions.closeRuntimeSettings, (state, action) => {
      NotificationReduxSlice.caseReducers.clearNotificationMessage(state);
    });
    builder.addCase(propertiesListModalsSlice.actions.toggleModal, (state, action) => {
      NotificationReduxSlice.caseReducers.clearNotificationMessage(state);
    });
  },
});

export const { clearNotificationMessage, setNotificationMessage } = NotificationReduxSlice.actions;

export default NotificationReduxSlice.reducer;
